const apiUrl = process.env.REACT_APP_API_URL;

// Fetch user progress
export const fetchUserProgress = async (userId) => {
  try {
    // console.log(`Fetching progress for user ID: ${userId}`);
    const response = await fetch(`${apiUrl}/user/${userId}/progress`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      // console.error("Error fetching progress:", errorData);
      return { success: false, message: errorData.message };
    }

    const data = await response.json();
    // console.log("Fetched user progress:", data);
    return { success: true, data };
  } catch (error) {
    // console.error("Unexpected error occurred while fetching progress:", error.message);
    return { success: false, message: "An unexpected error occurred." };
  }
};

// Save user progress
export const saveUserProgress = async (userId, conqueredCastles, totalPoints, castleId) => {
  try {
    const response = await fetch(`${apiUrl}/user/save-progress`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: userId,
        conquered_castles: conqueredCastles,
        total_points: totalPoints,
        castle_id: castleId, // ✅ this is required by your backend
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      return { success: false, message: errorData.message };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return { success: false, message: "An unexpected error occurred." };
  }
};


// ✅ Fetch gameplay count
export const fetchGameplayCount = async (userId) => {
  try {
    console.log(`🎯 Fetching gameplay count for user ID: ${userId}`);
    const response = await fetch(`${apiUrl}/users/${userId}/gameplay`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    if (!response.ok) {
      console.error("❌ Error fetching gameplay count:", data);
      return { success: false, message: data.message };
    }

    console.log("✅ Gameplay count fetched:", data);
    return { success: true, data };
  } catch (error) {
    console.error("❌ Unexpected error fetching gameplay count:", error.message);
    return { success: false, message: error.message };
  }
};

// ✅ Update gameplay count
export const updateGameplayCount = async (userId, newCount) => {
  try {
    console.log(`🔄 Updating gameplay count for user ${userId} to ${newCount}`);
    const response = await fetch(`${apiUrl}/users/${userId}/gameplay`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ gameplay_count: newCount }),
    });

    const data = await response.json();
    if (!response.ok) {
      console.error("❌ Error updating gameplay count:", data);
      return { success: false, message: data.message };
    }

    console.log("✅ Gameplay count updated:", data);
    return { success: true, data };
  } catch (err) {
    console.error("❌ Unexpected error updating gameplay count:", err.message);
    return { success: false, message: err.message };
  }
};


